/** Redis key on CONFIG_API for province/area tree */
export const CONFIG_AREA_LIST = '/view/v1/redis-keys/get-by-key?key=config-area-list'
